import script from "./MMultiSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./MMultiSelect.vue?vue&type=script&lang=ts&setup=true"

import "./MMultiSelect.vue?vue&type=style&index=0&id=701f0db0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701f0db0"]])

export default __exports__